import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { pastTransaction } from "../../services/Api";

export const fetchTransactions = createAsyncThunk(
    "transactions/fetchTransactions",
    async () => {
        let allTransactions = [];
        let page = 1;
        let totalPages = 1;

        do {
            const response = await pastTransaction({ page });
            const arr = Array.isArray(response.data) ? response.data : response.data.data;
            allTransactions = [...allTransactions, ...arr];
            totalPages = response.meta.last_page;
            page++;
        } while (page <= totalPages);

        return allTransactions.map(item => ({
            id: item.id,
            name: item.product?.product_name || '',
            barcode: item.product?.barcode_number || '',
            quantity: item.quantity,
            status: item.transaction_status === "Inbound" ? 'Inbound' : item.transaction_status === "Outbound" ? 'Outbound' : null,
            order: item.created_at ? new Date(item.created_at).toLocaleDateString('en-GB') : '',
            product: item.product 
        })).filter(item => item.status !== null);
    }
);

const initialState = {
    allTransactions: [],
    transactions: [],
    filterType: "all",
    loading: false,
    error: null,
};

const transactionsSlice = createSlice({
    name: "transactions",
    initialState,
    reducers: {
        setFilterType: (state, action) => {
            state.filterType = action.payload;
            let filtered = state.allTransactions || [];
        
            if (action.payload === "inbound") {
                filtered = filtered.filter(item => item.status === 'Inbound');
            } else if (action.payload === "outbound") {
                filtered = filtered.filter(item => item.status === 'Outbound');
            }
        
            // Ensure uniqueness and sort by order date
            const uniqueFiltered = Array.from(new Set(filtered.map(item => item.id)))
                .map(id => filtered.find(item => item.id === id));
        
            filtered = uniqueFiltered
                .filter(item => item.order)
                .sort((a, b) => new Date(b.order) - new Date(a.order))
                .slice(0, 5);
        
            state.transactions = filtered;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchTransactions.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchTransactions.fulfilled, (state, action) => {
                state.loading = false;
                state.allTransactions = action.payload;
                let filtered = action.payload
                    .filter(item => item.order)
                    .slice()
                    .sort((a, b) => {
                        const [da, ma, ya] = a.order.split("/").map(Number);
                        const [db, mb, yb] = b.order.split("/").map(Number);
                        return new Date(yb, mb - 1, db) - new Date(ya, ma - 1, da);
                    })
                    .slice(0, 5);
                state.transactions = filtered;
            })
            .addCase(fetchTransactions.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export const { setFilterType } = transactionsSlice.actions;
export default transactionsSlice.reducer;